const helper = {
  namespaced: true,

  //state
  state: {},

  //actions
  actions: {
    toBase64({}, data) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onloadend = function () {
          resolve(reader.result)
        }
        reader.readAsDataURL(data.file)
      })
    },
  },
}

export default helper
